import { type FusionError, serializeFusionError } from '../error/FusionError'
import { err, ok, Result } from "neverthrow"
import { ZodType } from "zod"
import _ from 'lodash'

export function safeParseJson<T>(buf: NodeJS.AllowSharedBufferSource|string, schema?: ZodType<T>): Result<T, FusionError> {
	try {
		let parsedObj: ReturnType<JSON['parse']>
		if(!_.isString(buf)) {
			// by default, decode will not throw an error,
			// it will instead replace invalid bytes invalid bytes with �
			const decoder = new TextDecoder()
			parsedObj = JSON.parse(decoder.decode(buf))
		} else {
			parsedObj = JSON.parse(buf)
		}
		if(!schema) {
			return ok(parsedObj)
		}
		let r = schema.safeParse(parsedObj)
		if(!r.success) {
			return err(serializeFusionError('safeParseJson', r.error))
		}
		return ok(r.data)
	} catch (ex) {
		return err(serializeFusionError('safeParseJson', ex))
	}
}

export function safeUnparseJson(obj: Object): Result<Uint8Array, FusionError> {
	try {
		const encoder = new TextEncoder()
		const strObj = JSON.stringify(obj)
		return ok(encoder.encode(strObj))
	} catch(ex) {
		return err(serializeFusionError('safeUnparseJson', ex))
	}
}
